import { GenericBackendResponse } from '../genericBackendResponse';
import { UserI } from '../users/interfaces/Users';
import { AdhesionMode } from '../users/getAdhesionDetails';

export interface CurrentConfig {
	contributionPeriodicity: string;
	participantContributionPerPeriod: number;
}

export interface RecommendedConfig {
	contributionPeriodicity: string;
	participantContributionPerPeriod: number;
}

export interface MaxAportationsInfoOutput {
	user: UserI;
	momentOfCalculation: Date;
	maxUserContributionThisYearNow: number;
	companyThisYearCompanyCommitted: number;
	maxUserContributionEndOfNextPeriod: number;
	currentConfig: CurrentConfig;
	recommendedConfig: RecommendedConfig;
	needToProvideGrossSalary: boolean;
	pendingYearContributionsForBonus: number;
	totalCompanyContributions: number;
	totalParticipantContributions: number;
	individualExtraAportations: number;
}

export interface CurrentConfigFreelance {
	contributionPeriodicity: string;
	contributionPerPeriod: number;
}

export interface RecommendedConfigFreelance {
	contributionPeriodicity: string;
	contributionPerPeriod: number;
}

export interface MaxAportationsInfoFreelanceOutput {
	user: UserI;
	pendingYearContributions: number;
	maxFreelanceContributionEndOfNextPeriod: number;
	currentConfig: CurrentConfigFreelance;
	recommendedConfig: RecommendedConfigFreelance;
	pendingYearContributionsForBonus: number;
	totalParticipantContributions: number;
}

const calculateMaxAportationsInfo = async (
	token: string,
	mode?: AdhesionMode
): Promise<
	GenericBackendResponse<MaxAportationsInfoOutput | MaxAportationsInfoFreelanceOutput>
> => {
	const response = await fetch(
		`${process.env.REACT_APP_BASE_API}/calculators/calculate-max-aportations-info`,
		{
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${token}`
			},
			...(mode ? { body: JSON.stringify({ mode }) } : {})
		}
	);

	return response.json();
};

export default calculateMaxAportationsInfo;
